/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { lazy, Fragment } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';
import { FieldContainer } from '../../UIKit-legacy/utils/FieldContainer';
import { FormStateChangeNotifier } from '../form';
var AkFormField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var AKTextArea = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.textarea' */
  '@atlaskit/textarea');
});
var AKErrorMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.ErrorMessage
    };
  });
});
var AKHelperMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var validate = function validate(value) {
  return !value ? 'EMPTY' : undefined;
};
var TextArea = function TextArea(props) {
  return jsx(FieldContainer, null, jsx(AkFormField, {
    name: props.name,
    label: props.label,
    defaultValue: props.defaultValue,
    isRequired: props.isRequired,
    validate: props.isRequired ? validate : undefined
  }, function (_ref) {
    var fieldProps = _ref.fieldProps,
      error = _ref.error;
    var id = fieldProps.id,
      isRequired = fieldProps.isRequired,
      isDisabled = fieldProps.isDisabled,
      isInvalid = fieldProps.isInvalid,
      onChange = fieldProps.onChange,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      value = fieldProps.value,
      ariaLabelledBy = fieldProps['aria-labelledby'];
    return jsx(Fragment, null, jsx(FormStateChangeNotifier, {
      name: props.name,
      value: fieldProps.value
    }), jsx(AKTextArea, {
      id: id,
      isRequired: isRequired,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      value: value,
      "aria-labelledby": ariaLabelledBy,
      appearance: "standard",
      resize: "smart",
      minimumRows: 2,
      isMonospaced: props.isMonospaced,
      placeholder: props.placeholder,
      spellCheck: props.spellCheck
    }), error === 'EMPTY' && jsx(AKErrorMessage, null, jsx(FormattedMessage, messages.requiredFieldMessage)), props.description && jsx(AKHelperMessage, null, props.description));
  }));
};
export default TextArea;
export var TextAreaFn = function TextAreaFn(_ref2) {
  var props = _ref2.props;
  var _ref3 = props,
    name = _ref3.name,
    label = _ref3.label,
    defaultValue = _ref3.defaultValue,
    isMonospaced = _ref3.isMonospaced,
    isRequired = _ref3.isRequired,
    description = _ref3.description,
    placeholder = _ref3.placeholder,
    spellCheck = _ref3.spellCheck;
  return jsx(TextArea, {
    name: name,
    label: label,
    defaultValue: defaultValue,
    isMonospaced: isMonospaced,
    isRequired: isRequired,
    placeholder: placeholder,
    description: description,
    spellCheck: spellCheck
  });
};
var messages = defineMessages({
  requiredFieldMessage: {
    id: 'confluence.text.area.required.field.message',
    defaultMessage: 'This field is required.',
    description: 'This message alerts the user that a field is required.'
  }
});